export default __webpack_public_path__ + "static/media/CNo.71-4.9c453cfa.jpg";